module.exports = __webpack_public_path__ + "static/media/dealwithit.b9df8afa.gif";